import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import logo from "../../../Assets/ViralOmics/logo.png"

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: "Home", to: "/viralomics" },
    { label: "Access Database", to: "/viralomics/database" },
    { label: "Tools", to: "/viralomics/tools" },
    { label: "About", to: "/viralomics/about" },
    { label: "Contact Us", to: "/viralomics/contact" },
  ];

  return (
    <>
      <style>{`
        .nav-root {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 100;

          padding: 1.1rem clamp(1.5rem, 4vw, 4rem);

          display: flex;
          align-items: center;
          justify-content: space-between;

          backdrop-filter: blur(18px);
          -webkit-backdrop-filter: blur(18px);

          transition: background 0.4s, border-color 0.4s;

          font-family: 'Inter', sans-serif;

          background: rgba(247, 249, 252, 0.94);

          border-bottom: 1px solid rgba(100, 116, 139, 0.16);

          box-shadow: 0 1px 12px rgba(23, 43, 77, 0.04);
        }

        .nav-logo {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          width: 155px;
          height: 52px;
          overflow: visible;
          padding-left: 50px;
        }

        @media (max-width: 960px) {
          .nav-logo {
            padding-left: 30px;
          }
        }

        .nav-logo a {
          display: flex;
          align-items: center;
          width: 155px;
          height: 52px;
          overflow: visible;
        }

        .nav-logo-image {
          display: block;
          width: 155px;
          height: 52px;
          object-fit: contain;
          cursor: pointer;
          user-select: none;

          /* Only visually enlarge the logo */
          transform: scale(2.4);
          transform-origin: center;
        }

        .nav-links {
          display: flex;
          gap: clamp(1rem, 2vw, 2.4rem);

          align-items: center;

          flex: 1;
          justify-content: center;
        }

        .nav-link {
          font-size: 0.79rem;
          font-weight: 500;

          letter-spacing: 0.07em;
          text-transform: uppercase;

          color: #64748B;

          text-decoration: none;

          background: none;
          border: none;

          cursor: pointer;

          padding: 0.1rem 0;

          font-family: 'Inter', sans-serif;

          transition: color 0.25s;

          position: relative;

          white-space: nowrap;
        }

        .nav-link::after {
          content: '';

          position: absolute;

          bottom: -5px;
          left: 0;
          right: 0;

          height: 2px;

          background: #0F766E;

          transform: scaleX(0);

          transition: transform 0.25s;

          transform-origin: left;
        }

        .nav-link:hover {
          color: #0F766E;
        }

        .nav-link:hover::after {
          transform: scaleX(1);
        }

        .hamburger {
          display: none;

          flex-direction: column;
          gap: 5px;

          cursor: pointer;

          background: none;
          border: none;

          padding: 4px;

          flex-shrink: 0;
        }

        .hamburger span {
          display: block;

          width: 22px;
          height: 1.5px;

          background: #172B4D;

          transition:
            transform 0.3s,
            opacity 0.3s;
        }

        .mobile-menu {
          display: none;

          position: fixed;

          top: 90px;
          left: 0;
          right: 0;

          background: rgba(247, 249, 252, 0.98);

          backdrop-filter: blur(18px);
          -webkit-backdrop-filter: blur(18px);

          border-bottom: 1px solid rgba(100, 116, 139, 0.16);

          box-shadow: 0 8px 24px rgba(23, 43, 77, 0.06);

          flex-direction: column;
          align-items: center;

          z-index: 99;

          font-family: 'Inter', sans-serif;
        }

        .mobile-menu.open {
          display: flex;
        }

        .mobile-link {
          width: 100%;

          text-align: center;

          padding: 1rem;

          font-size: 0.82rem;
          font-weight: 500;

          letter-spacing: 0.1em;

          text-transform: uppercase;

          color: #64748B;

          background: none;
          border: none;

          border-bottom: 1px solid rgba(100, 116, 139, 0.10);

          cursor: pointer;

          font-family: 'Inter', sans-serif;

          transition:
            color 0.2s,
            background 0.2s;

          text-decoration: none;
        }

        .mobile-link:hover {
          color: #0F766E;

          background: rgba(15, 118, 110, 0.04);
        }

        @media (max-width: 960px) {
          .nav-links {
            display: none !important;
          }

          .hamburger {
            display: flex !important;
          }
        }
      `}</style>

      <nav className="nav-root">
        <div className="nav-logo">
          <Link to="/viralomics">
            <img
              src={logo}
              alt="ViralOmics"
              className="nav-logo-image"
            />
          </Link>
        </div>

        <div className="nav-links">
          {links.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className="nav-link"
            >
              {label}
            </Link>
          ))}
        </div>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span
            style={{
              transform: menuOpen
                ? 'translateY(6.5px) rotate(45deg)'
                : 'none'
            }}
          />

          <span
            style={{
              opacity: menuOpen ? 0 : 1
            }}
          />

          <span
            style={{
              transform: menuOpen
                ? 'translateY(-6.5px) rotate(-45deg)'
                : 'none'
            }}
          />
        </button>
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {links.map(({ label, to }) => (
          <Link
            key={to}
            to={to}
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            {label}
          </Link>
        ))}
      </div>
    </>
  );
}
